import Relay from 'react-relay';

class ClassifyResourcesMutation extends Relay.Mutation {
  getMutation = () => Relay.QL`mutation {classifyResources}`;

  getVariables() {
    return {
      targetType: this.props.targetType,
      resources: this.props.resources,
    };
  }
  getFatQuery() {
    return Relay.QL`
      fragment on ClassifyResourcesPayload {
        contacts {
          id
          displayName
          email
        }
        meetingRooms {
          id
          displayName
          email
        }
        otherResources {
          id
          displayName
          email
        }
      }
    `;
  }
  getConfigs() {
    return [{
      type: 'REQUIRED_CHILDREN',
      children: [Relay.QL`
        fragment on ClassifyResourcesPayload {
          contacts {
            id
            displayName
            email
          }
          meetingRooms {
            id
            displayName
            email
          }
          otherResources {
            id
            displayName
            email
          }
        }
      `],
    }];
  }
}

export default ClassifyResourcesMutation;



// WEBPACK FOOTER //
// ./src/js/Mutations/ClassifyResourcesMutation.js